<template>
  <section class="content">
    <div class="row">
      <div class="col-md-6">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">Branch : {{ singleLoanBranchDetail.name }}</h3>
          </div>

          <div class="box-body no-padding">
            <table class="table table-condensed">
            <tbody>
              <tr>
                <th style="width: 10px">#</th>
                <th>ApplicationNo : {{ singleLoanMemberLoanPlan.applicationNo }}</th>
                <th>Total Amount : {{ singleLoanMemberLoanPlan.totalAmt}}</th>
              </tr>
              <tr>
                <td>1.</td>
                <td>Disbursement Date</td>
                <td>{{ singleLoanDisbursement.disbursementDate | myDate }}</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>First EMI Date</td>
                <td>{{ singleLoanDisbursement.emiStartDate | myDate }}</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Last EMI Date</td>
                <td>{{ singleLoanDisbursement.emiEndDate | myDate }}</td>
              </tr>
              <tr>
                <td>4.</td>
                <td>Amount</td>
                <td>{{ singleLoanDisbursementPlan.amount }}</td>
              </tr>
              <tr>
                <td>5.</td>
                <td>EMI</td>
                <td>{{ singleLoanDisbursementPlan.emi }}</td>
              </tr>
              <tr>
                <td>6.</td>
                <td>File Charge</td>
                <td>{{ singleLoanDisbursementPlan.fileCharge }}</td>
              </tr>
              <tr>
                <td>7.</td>
                <td>Processing Fee</td>
                <td>{{ singleLoanDisbursementPlan.processingFee }}</td>
              </tr>
              <tr>
                <td>8.</td>
                <td>Insurance Fee</td>
                <td>{{ singleLoanDisbursementPlan.insuranceFee }}</td>
              </tr>
              <tr>
                <td>9.</td>
                <td>Rate Of Interest</td>
                <td>{{ singleLoanDisbursementPlan.rateOfInterest }}</td>
              </tr>
              <tr>
                <td>10.</td>
                <td>Total Amount To Pay</td>
                <td>{{ singleLoanDisbursementPlan.totalAmtToPay }}</td>
              </tr>
              <tr>
                <td>11.</td>
                <td>Description</td>
                <td>{{ singleLoanDisbursementPlan.description }}</td>
              </tr>
            </tbody></table>
          </div>

        </div>
      </div>
      <div class="col-md-6">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">Loan Plan </h3>
          </div>

          <div class="box-body no-padding">
            <table class="table table-condensed" v-if="Object.keys(singleLoanDisbursement).length > 0">
              <tbody>
                <tr>
                  <th style="width: 10px">#</th>
                  <th>Staff : <span v-if="singleLoanDisbursement.agent">{{ singleLoanDisbursement.agent.name }}</span></th>
                  <th>Code : <span v-if="singleLoanDisbursement.agent">{{ singleLoanDisbursement.agent.code}}</span></th>
                </tr>
                <tr>
                  <td>1.</td>
                  <td>Plan Name</td>
                  <td>{{ singleLoanDisbursementPlan.name }}</td>
                </tr>
                <tr>
                  <td>2.</td>
                  <td>Plan Type</td>
                  <td>{{ singleLoanDisbursementPlan.planType }}</td>
                </tr>
                <tr>
                  <td>3.</td>
                  <td>Number Of Payments</td>
                  <td>{{ singleLoanDisbursementPlan.noOfPayments }}</td>
                </tr>
                <tr>
                  <td>4.</td>
                  <td>Recovery Type</td>
                  <td>{{ singleLoanDisbursementPlan.recoveryType }}</td>
                </tr>
                <tr>
                  <td>5.</td>
                  <td>Type Of Interest</td>
                  <td>{{ singleLoanDisbursementPlan.typeOfInterest }}</td>
                </tr>
                <tr>
                  <td>6.</td>
                  <td>File Charge Include</td>
                  <td>{{ singleLoanDisbursementPlan.fileChargeIncludeAmt }}</td>
                </tr>
                <tr>
                  <td>7.</td>
                  <td>Processing Fee Include</td>
                  <td>{{ singleLoanDisbursementPlan.processingFeeIncludeAmt }}</td>
                </tr>
                <tr>
                  <td>8.</td>
                  <td>Processing Fee Type</td>
                  <td>{{ singleLoanDisbursementPlan.processingFeeType }}</td>
                </tr>
                <tr>
                  <td>9.</td>
                  <td>Insurance Fee Include</td>
                  <td>{{ singleLoanDisbursementPlan.insuranceFeeIncludeAmt }}</td>
                </tr>
                <tr>
                  <td>10.</td>
                  <td>Insurance Fee Type</td>
                  <td>{{ singleLoanDisbursementPlan.insuranceFeeType }}</td>
                </tr>
                <tr>
                  <td>11.</td>
                  <td>Include GST</td>
                  <td>{{ singleLoanDisbursementPlan.includeGst }}</td>
                </tr>
                <tr>
                  <td>12.</td>
                  <td>Created By</td>
                  <td>{{ singleLoanDisbursementPlan.created_by.name }} ({{ singleLoanDisbursementPlan.created_by.code }})</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'singleloandetails',
  props: {
    singleLoanBranchDetail: {},
    singleLoanMemberLoanPlan: {},
    singleLoanDisbursement: {},
    singleLoanMemberDetail: {},
    singleLoanDisbursementPlan: {}
  }
}
</script>



// WEBPACK FOOTER //
// SingleLoanDetails.vue?200a3a81